import { Component, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'warema-no-offer-request-search-results',
    templateUrl: './no-offer-request-search-results.component.html',
    styleUrls: ['./no-offer-request-search-results.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class NoOfferRequestSearchResultsComponent {
    public readonly redirectToAppointmentCreation = output<void>();
}
